var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.name,staticClass:"category",class:{
      active: category.name === _vm.selectedCategory,
      soon: category.disabled
    },on:{"click":function($event){!category.disabled && _vm.selectCategory(category)}}},[_c(category.icon,{tag:"component"}),_c('span',[_vm._v(_vm._s(_vm.$t(category.name)))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }